import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import {
  AddNewEmployeeState,
  GetAllJobType,
  VendorDetailsTypes,
} from '../../../../types/EmployeeDirectory/EmployeesList/AddNewEmployee/addNewEmployeeType'
import { LoadingState, ValidationError } from '../../../../types/commonTypes'
import { ApiLoadingState } from '../../../../middleware/api/apiList'
import { RootState } from '../../../../stateStore'
import addNewEmployeeAPi from '../../../../middleware/api/EmployeeDirectory/EmployeesList/AddNewEmployee'

const getAllJobType = createAsyncThunk(
  'getAllJobTypes/getAllJobType',
  async (_, thunkApi) => {
    try {
      return await addNewEmployeeAPi.getJobTypesApi.getJobTypes()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const getVendorDetails = createAsyncThunk(
  'getAllJobTypes/getVendorDetails',
  async (_, thunkApi) => {
    try {
      return await addNewEmployeeAPi.getJobTypesApi.getVendorDetails()
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

const initialGetAllJobTypeState: AddNewEmployeeState = {
  jobTypes: [],
  error: null,
  isLoading: ApiLoadingState.idle,
  vendorDetails: [],
}
const getAllJobTypesSlice = createSlice({
  name: 'getAllJobTypes',
  initialState: initialGetAllJobTypeState,
  reducers: {
    clearjobTypes: (state) => {
      state.jobTypes = []
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllJobType.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
      .addCase(getAllJobType.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.jobTypes = action.payload as GetAllJobType[]
      })
      .addCase(getAllJobType.rejected, (state, action) => {
        state.isLoading = ApiLoadingState.failed
        state.error = action.payload as ValidationError
      })
      .addCase(getVendorDetails.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.vendorDetails = action.payload
      })
  },
})

const isLoading = (state: RootState): LoadingState =>
  state.getJobTypes.isLoading
const jobTypes = (state: RootState): GetAllJobType[] =>
  state.getJobTypes.jobTypes as GetAllJobType[]

const vendorDetailsTypes = (state: RootState): VendorDetailsTypes[] =>
  state.getJobTypes.vendorDetails as VendorDetailsTypes[]
const getAllJobTypesThunk = {
  getAllJobType,
  getVendorDetails,
}

const jobTypesSelectors = {
  isLoading,
  jobTypes,
  vendorDetailsTypes,
}

export const jobTypeService = {
  ...getAllJobTypesThunk,
  actions: getAllJobTypesSlice.actions,
  selectors: jobTypesSelectors,
}

export default getAllJobTypesSlice.reducer
